import api from './api';

export const updateAnnouncement = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let fileBase64 = data.fileBase64 || '';
    let pictureBase64 = data.pictureBase64 || '';
    let keepExistingPicture = false;
    let keepExistingFile = false;

    // Eğer yeni bir resim seçilmemiş ve mevcut bir resim URL'si varsa
    if (!data.picture && (data.pictureUrl || data.existingPictureUrl)) {
      const pictureUrl = data.existingPictureUrl || data.pictureUrl;
      console.log('Mevcut resim korunacak:', pictureUrl);
      keepExistingPicture = true;
    } else if (!data.picture && !data.pictureUrl && !data.existingPictureUrl) {
      // Eğer resim seçilmemiş ve mevcut resim de yoksa, boş gönder
      pictureBase64 = '';
      keepExistingPicture = false;
      console.log('Resim seçilmedi ve mevcut resim yok, boş gönderiliyor');
    }

    // Eğer yeni bir dosya seçilmemiş ve mevcut bir dosya URL'si varsa
    if (!data.file && (data.fileUrl || data.existingFileUrl)) {
      const fileUrl = data.existingFileUrl || data.fileUrl;
      console.log('Mevcut dosya korunacak:', fileUrl);
      keepExistingFile = true;
    } else if (!data.file && !data.fileUrl && !data.existingFileUrl) {
      // Eğer dosya seçilmemiş ve mevcut dosya da yoksa, boş gönder
      fileBase64 = '';
      keepExistingFile = false;
      console.log('Dosya seçilmedi ve mevcut dosya yok, boş gönderiliyor');
    }

    // Convert picture to base64 if it's a File object
    if (data.picture && data.picture instanceof File) {
      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const base64 = reader.result;
          console.log('Resim base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.picture.size / 1024).toFixed(2)} KB`,
            base64Size: `${(base64.length * 0.75 / 1024).toFixed(2)} KB`,
            base64Preview: `${base64.substring(0, 100)}...`
          });
          resolve(base64);
        };
        reader.onerror = error => reject(error);
      });
    }

    // Convert file to base64 if it's a File object
    if (data.file && data.file instanceof File) {
      fileBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.file);
        reader.onload = () => {
          const base64 = reader.result;
          console.log('Dosya base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.file.size / 1024).toFixed(2)} KB`,
            base64Size: `${(base64.length * 0.75 / 1024).toFixed(2)} KB`,
            base64Preview: `${base64.substring(0, 100)}...`
          });
          resolve(base64);
        };
        reader.onerror = error => reject(error);
      });
    }

    const payload = {
      guid: data.guid,
      date: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      pictureBase64: pictureBase64,
      fileBase64: fileBase64,
      keepExistingPicture: keepExistingPicture,
      keepExistingFile: keepExistingFile,
      existingPictureUrl: data.existingPictureUrl || data.pictureUrl || '',
      existingFileUrl: data.existingFileUrl || data.fileUrl || ''
    };

    console.log('Güncellenecek duyuru verisi:', {
      guid: payload.guid,
      date: payload.date,
      header: payload.header,
      detail: payload.detail,
      picture: pictureBase64 ? {
        size: `${(pictureBase64.length * 0.75 / 1024).toFixed(2)} KB`,
        preview: `${pictureBase64.substring(0, 50)}...`
      } : null,
      file: fileBase64 ? {
        size: `${(fileBase64.length * 0.75 / 1024).toFixed(2)} KB`,
        preview: `${fileBase64.substring(0, 50)}...`
      } : null
    });

    const response = await api.post('/api/Announcement/UpdateAnnouncement', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    // API true veya "true" dönebilir, ikisini de kontrol edelim
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error updating announcement:', error);
    throw error;
  }
};

export const getAnnouncements = async (params) => {
  try {
    console.log('Sending request with params:', params);
    const token = localStorage.getItem('token');
    const response = await api.post('/api/Announcement/GetActiveAnnouncement', params, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Raw API Response:', response);
    // Ensure we return a value that the UI can properly interpret as success
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error fetching announcements:', error);
    throw error;
  }
};

export const deleteAnnouncement = async (guid) => {
  try {
    console.log('Sending request to delete announcement with guid:', guid);
    const token = localStorage.getItem('token');
    const response = await api.post(`/api/Announcement/DeleteAnnouncement`, {
      guid: guid
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Raw API Response:', response);
    // Ensure we return a value that the UI can properly interpret as success
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error deleting announcement:', error);
    throw error;
  }
};

export const addAnnouncement = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let fileBase64 = '';
    let pictureBase64 = '';

    // Resim ve dosya bilgilerini logla
    if (data.picture) {
      console.log('Resim dönüştürülüyor:', {
        name: data.picture.name,
        type: data.picture.type,
        size: `${(data.picture.size / 1024).toFixed(2)} KB`
      });
    }

    if (data.file) {
      console.log('Dosya dönüştürülüyor:', {
        name: data.file.name,
        type: data.file.type,
        size: `${(data.file.size / 1024).toFixed(2)} KB`
      });
    }

    // Convert picture to base64 if it exists
    if (data.picture) {
      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const base64 = reader.result; // Keep the full data URL format
          console.log('Resim base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.picture.size / 1024).toFixed(2)} KB`,
            base64Size: `${(base64.length * 0.75 / 1024).toFixed(2)} KB`,
            base64Preview: `${base64.substring(0, 100)}...`
          });
          resolve(base64);
        };
        reader.onerror = error => reject(error);
      });
    }

    // Convert file to base64 if it exists
    if (data.file) {
      fileBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.file);
        reader.onload = () => {
          const base64 = reader.result; // Keep the full data URL format
          console.log('Dosya base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.file.size / 1024).toFixed(2)} KB`,
            base64Size: `${(base64.length * 0.75 / 1024).toFixed(2)} KB`,
            base64Preview: `${base64.substring(0, 100)}...`
          });
          resolve(base64);
        };
        reader.onerror = error => reject(error);
      });
    }

    const payload = {
      date: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      pictureBase64: pictureBase64,
      fileBase64: fileBase64
    };

    console.log('Gönderilecek duyuru verisi:', {
      date: payload.date,
      header: payload.header,
      detail: payload.detail,
      picture: pictureBase64 ? {
        size: `${(pictureBase64.length * 0.75 / 1024).toFixed(2)} KB`,
        preview: `${pictureBase64.substring(0, 50)}...`,
        isValid: pictureBase64.length > 0 && /^[A-Za-z0-9+/=]+$/.test(pictureBase64)
      } : null,
      file: fileBase64 ? {
        size: `${(fileBase64.length * 0.75 / 1024).toFixed(2)} KB`,
        preview: `${fileBase64.substring(0, 50)}...`,
        isValid: fileBase64.length > 0 && /^[A-Za-z0-9+/=]+$/.test(fileBase64)
      } : null
    });

    const response = await api.post('/api/Announcement/AddAnnouncement', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Announcement added successfully:', response);
    return response;

  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('API Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Network Error - No response received');
    } else {
      // Something happened in setting up the request
      console.error('Error:', error.message);
    }
    throw error;
  }
};
